import {Pipe, PipeTransform} from "@angular/core";
import {WrenchLocation} from "../_models/location";

@Pipe({
    name: 'fullAddress'
})
export class FullAddressPipe implements PipeTransform {

    transform(data: WrenchLocation) {
        const address: string[] = [];

        if (data && data.address && data.city && data.state && data.zip) {
            if (data.label) {
                address.push(`${data.label} - `);
            }

            // assume address, city, state, and zip and always populated
            address.push(`${data.address}, ${data.city}, ${data.state} ${data.zip}`);
        }

        return address.join('');
    } // transform()

} // FullAddressPipePipe
